import script from "./TransactUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactUserView.vue?vue&type=script&setup=true&lang=js"

import "./TransactUserView.vue?vue&type=style&index=0&id=ecf578fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf578fe"]])

export default __exports__